<template>
    <div class="z-table" :class="buildClass">
        <div class="z-table__container">
            <table>
                <caption v-if="captionText" v-html="captionText"></caption>
                <colgroup v-if="colgroup && colgroup.length">
                    <col
                        v-for="(item, index) in colgroup"
                        :key="index"
                        span="1"
                        :style="`width: ${item};`"
                    >
                </colgroup>
                <thead>
                    <tr class="z-table-row z-table-row--head">
                        <template v-if="this.sortable">
                            <th
                                class="z-table-col z-table-col--head"
                                :class="[
                                    {'z-table-col--big' : bigHead},
                                    {'z-table-col--sort-asc' : ( columnSort === index && ascendedSort)},
                                    {'z-table-col--sort-desc' : ( columnSort === index && !ascendedSort)}
                                ]"
                                v-for="(item, index) in columns"
                                :key="index"
                                @click="sortColumn(item, index)"
                            >
                                <div class="z-table-col__inner">
                                    <vue-raw class="z-table-col__text" :raw="item" />
                                    <z-icon
                                        class="z-table-col__icon"
                                        name="modal-arrow"
                                        width="20px"
                                        height="20px"
                                    ></z-icon>
                                </div>
                            </th>
                        </template>
                        <template v-else>
                            <th
                                class="z-table-col z-table-col--head"
                                :class="{'z-table-col--big' : bigHead}"
                                v-for="(item, index) in columns"
                                :key="index"
                            >
                                <vue-raw :raw="item" />
                            </th>
                        </template>
                    </tr>
                </thead>
                <tbody>
                    <slot />
                </tbody>
            </table>
        </div>
        <div class="z-table__footer" v-if="hasAddSlotData">
            <slot name="add" />
        </div>
    </div>
</template>

<script>
import { mixinDevice } from '@/utils/mixin'

export default {
    name: 'z-table',
    mixins: [mixinDevice],
    data () {
        return {
            columnSort: null,
            ascendedSort: true
        }
    },
    props: {
        columns: {
            type: Array,
            required: true,
            default: () => []
        },
        colgroup: {
            type: Array,
            default: () => []
        },
        captionText: {
            type: String,
            default: ''
        },
        data: {
            type: Array,
            default: () => []
        },
        fixed: Boolean,
        financial: Boolean,
        responsive: Boolean,
        scrollable: {
            type: Boolean,
            default: true
        },
        bigHead: {
            type: Boolean,
            default: false
        },
        sortable: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        hasAddSlotData () {
            return this.$slots.add
        },
        buildClass () {
            return {
                'z-table--fixed': this.fixed,
                'z-table--financial': this.financial,
                'z-table--scrollable': this.scrollable,
                'z-table--responsive': this.responsive,
                'z-table--sortable': this.sortable
            }
        }
    },
    methods: {
        sortColumn (item, index) {
            if (this.columnSort === index) {
                this.ascendedSort = !this.ascendedSort
            } else {
                this.columnSort = index
            }
            this.$emit('click', item, index, this.ascendedSort)
        }
    }
}
</script>

<style lang="scss" src="./index.scss"></style>
